import { cn } from "../../lib/utils";

export function PageHeader({ title, subtitle, action, className }) {
  return (
    <div className={cn("flex items-end justify-between gap-4 mb-6", className)}>
      <div>
        <div className="overline mb-1">SiteSync</div>
        <h1 className="text-2xl md:text-3xl font-semibold tracking-tight">{title}</h1>
        {subtitle && (
          <div className="text-sm text-muted-foreground mt-1 max-w-2xl">{subtitle}</div>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

export function StatCard({ label, value, foot, testId }) {
  return (
    <div className="border border-border bg-card rounded-sm p-5" data-testid={testId}>
      <div className="overline mb-2">{label}</div>
      <div className="metric text-3xl md:text-4xl font-semibold">{value}</div>
      {foot && <div className="text-xs text-muted-foreground mt-2">{foot}</div>}
    </div>
  );
}

export function EmptyState({ title, body, action }) {
  return (
    <div className="border border-dashed border-border rounded-sm p-10 text-center">
      <div className="overline mb-2">Empty</div>
      <div className="text-lg font-semibold mb-1">{title}</div>
      {body && <div className="text-sm text-muted-foreground mb-4 max-w-md mx-auto">{body}</div>}
      {action}
    </div>
  );
}
